export default commomImport => [{
  path: `edit-product`,
  name: 'add',
  hidden: true,
  meta: {
    title: 'product.editProduct',
    noCache: true
  },
  //  全部订单
  component: commomImport('product-manager/product-list/add')
}];
